import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';

// Data table
import { Skeletonitems, SkeletonbodyTemplate } from '../../../../appconfig/Settings';

import { MasterTab } from '../../MasterTab';
import { getAllDetails, getAllDetailsDirect, postAllData } from '../../../../service/ProductService';
import { APPLICATIONS, BILL_ITEM, BILL_MASTER } from '../../../../config/ApiConstant';
import { AddAppBillMasterValidate } from '../../../../config/Validate';
import { ApplicationBillMasterColumns } from '../../../../appconfig/DatatableSetting';

export const ApplicationBillMaster = () => {
    document.title = 'Application Bill Master | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [applications, setApplications] = useState<any>([]);
    const [billItems, setBillItems] = useState<any>([]);
    const [appBillMasterData, setAppBillMasterData] = useState<any>({});
    const [totalAmount, setTotalAmount] = useState<any>('');
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [tableBillItems, setTableBillItems] = useState<any>([]);
    const [errors, setErrors] = useState<any>({});

    // useEffect
    useEffect(() => {
        getAllApplications();
        getBillItems();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        getAllApplicationBills();
    }, [appBillMasterData?.applicationName?.code]);

    // Get all applications
    const getAllApplications = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(APPLICATIONS);
            if (response) {
                let appOption: any = [];
                response.map((option: any) => {
                    const row = {
                        name: option.AppName,
                        code: option.SrNo
                    };
                    appOption.push(row);
                });
                setApplications(appOption);
                setPageLoad(true);
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get bill items
    const getBillItems = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(BILL_ITEM);
            if (response) {
                let billOption: any = [];
                response.map((option: any) => {
                    const row = {
                        name: option.BillItem,
                        code: option.SrNo
                    };
                    billOption.push(row);
                });
                setBillItems(billOption);
                setPageLoad(true);
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setAppBillMasterData({});
        setTotalAmount('');
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'applicationName' || name === 'itemName') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setAppBillMasterData({ ...appBillMasterData, [name]: val });
    };

    // Add application bill master
    const addAppBillMaster = async () => {
        try {
            const { errors, isError } = AddAppBillMasterValidate(appBillMasterData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSubmitLoading(true);

                let formData: any = new FormData();
                formData.append('AppSrNo', appBillMasterData?.applicationName?.code);
                formData.append('BillName', appBillMasterData?.applicationName?.name);
                formData.append('BillItemSrNoseq', appBillMasterData?.itemName?.code);
                formData.append('BillItemNmSeq', appBillMasterData?.itemName?.label);

                const response = await postAllData(BILL_MASTER, formData);
                if (response) {
                    getAllApplicationBills();
                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                }
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all application bills
    const getAllApplicationBills = async () => {
        try {
            setPageLoad(false);

            const response = await getAllDetails(BILL_MASTER + '?AppSrNo=' + appBillMasterData?.applicationName?.code);

            //Check response
            if (response) {
                const { bill_items, TotalValue } = response;
                setTableBillItems(bill_items);
                setTotalAmount(TotalValue);
                setPageLoad(true);
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    return (
        <>
            <MasterTab mainTabLabel="Application Bill Master" />
            <Toast ref={toast} />
            <div className="card mt-4">
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="applicationName">
                            Application <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={appBillMasterData?.applicationName}
                                name="applicationName"
                                options={applications}
                                filter
                                optionLabel="name"
                                placeholder="Select Application"
                                onChange={(e) => onInputChange(e.value, 'applicationName')}
                                className={errors['applicationName'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['applicationName']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="itemName">
                            Items <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={appBillMasterData?.itemName}
                                name="itemName"
                                options={billItems}
                                filter
                                optionLabel="name"
                                placeholder="Select Bill Item"
                                onChange={(e) => onInputChange(e.value, 'itemName')}
                                className={errors['itemName'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['itemName']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="totalAmount">Total Amount</label>
                        <div className="input-effect-div">
                            <InputText value={totalAmount} name="totalAmount" disabled={true} />
                        </div>
                        <small className="p-invalid-txt">{errors['totalAmount']}</small>
                    </div>
                </div>

                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button label="Clear" icon="pi pi-times" onClick={() => clearAll()} className="p-button-secondary mr-2" />
                            <Button label="ADD" icon="pi pi-check" onClick={() => addAppBillMaster()} loading={submitLoading} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                {/* Datatable */}
                {pageLoad ? (
                    <>
                        <DataTable
                            value={tableBillItems}
                            showGridlines
                            stripedRows
                            globalFilter={globalFilter}
                            filters={globalFieldFilter}
                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                            className="datatable-responsive "
                            emptyMessage="No Data Found"
                        >
                            {ApplicationBillMasterColumns.map((col, i) => {
                                return <Column key={col.field} field={col.field} header={col.header} />;
                            })}
                        </DataTable>
                    </>
                ) : (
                    <>
                        {/* Skeleton Data table */}
                        <DataTable value={Skeletonitems}>
                            {ApplicationBillMasterColumns.map((col, i) => (
                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                            ))}
                        </DataTable>
                    </>
                )}
            </div>
        </>
    );
};
